import _CircularProgress from "@mui/material/CircularProgress";
import _Close from "@mui/icons-material/Close";
import _Card from "@mui/material/Card";
import _CardContent from "@mui/material/CardContent";
import _ButtonBase from "@mui/material/ButtonBase";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import avantagesGeoveloImage from '../assets/images/news/avantages-geovelo.jpeg';
import avantagesVelotafImage from '../assets/images/news/avantages-velotaf.png';
import bienfaitsSanteImage from '../assets/images/news/bienfaits-sante.png';
import bienfaitsVeloImage from '../assets/images/news/bienfaits-velo.png';
import bonsGestesImage from '../assets/images/news/bons-gestes.png';
import comparatifGeoveloImage from '../assets/images/news/comparatif-geovelo.png';
import halloweenGameImage from '../assets/images/news/halloween-game.png';
import impactsImage from '../assets/images/news/impacts.png';
import starterPackImage from '../assets/images/news/starter-pack.png';
import { Button, SendIcon, StickyBar } from '../components';
import { useCancellablePromise } from '../hooks';
import { GeogroupNewsPost } from '../models';
import { AppService, GeogroupService } from '../services';
const now = moment();
function NewsModelFormContent({
  alternate,
  isSubmitting,
  models,
  selectModelId,
  selectedModelId,
  palette
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexWrap: "wrap",
    gap: 2
  }, models.map(newsPost => /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    key: newsPost.id,
    width: {
      xs: '100%',
      md: alternate ? 'calc((100% - 32px) / 3)' : 'calc((100% - 16px) / 2)'
    }
  }, /*#__PURE__*/React.createElement(_ButtonBase, {
    disabled: isSubmitting,
    onClick: () => selectModelId(newsPost.id),
    sx: {
      bgcolor: '#fff',
      borderRadius: 4,
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    border: `2px solid ${newsPost.id === selectedModelId ? palette.primary.main : '#e3e7ee'}`,
    borderRadius: 4,
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    maxWidth: "100%"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "stretch",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2,
    maxWidth: "100%",
    overflow: "hidden",
    padding: 2
  }, newsPost.photo && /*#__PURE__*/React.createElement("img", {
    src: newsPost.photo,
    width: 200
  }), /*#__PURE__*/React.createElement(_Typography, {
    dangerouslySetInnerHTML: {
      __html: newsPost.text
    },
    sx: {
      '& a': {
        pointerEvents: 'none'
      }
    },
    textAlign: "left",
    variant: "body2"
  })))))));
}
export function NewsModelForm({
  Link,
  alternate,
  prevPath,
  currentUser,
  currentPartner,
  geogroup,
  drawerWidth,
  showCyclingInsightsModels,
  onCreated
}) {
  const [isSubmitting, setSubmitting] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    frontendUrl
  } = AppService.environment;
  const halloweenGameId = frontendUrl === 'https://dev.geovelo.app' ? 22 : 108;
  const [models] = useState([...(showCyclingInsightsModels ? [new GeogroupNewsPost(9, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, `Rejoignez les cyclistes du territoire déjà inscrits pour tenter de faire gagner votre équipe ! <a href="${frontendUrl}/games/hub/${halloweenGameId}/">Inscrivez-vous ici</a>.`, halloweenGameImage, null, null, 'manual')] : []), new GeogroupNewsPost(1, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, 'Le vélo, allié de la planète : économie ressources, silence urbain, routes fluides. Zéro CO2, pollution minimale. Pédalons vers un avenir durable ! 🌍🚲', bienfaitsVeloImage, null, null, 'manual'), new GeogroupNewsPost(2, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, "Parfois, on n'a pas vraiment le choix… Mais pour un 10km, la question se pose ! 🤔🚲", impactsImage, null, null, 'manual'), new GeogroupNewsPost(3, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, "Le vélo libère l'esprit, améliore l'humeur et la concentration. En pédalant, le stress s'efface, l'anxiété s'apaise et la clarté mentale s'accroît. 🚴🧠", bienfaitsSanteImage, null, null, 'manual'), new GeogroupNewsPost(4, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, 'Voici les accessoires incontournables pour votre nouveau vélo ! 🚲😎', starterPackImage, null, null, 'manual'), new GeogroupNewsPost(5, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, 'Changeons le monde par de petits gestes au quotidien : pédaler, baisser le chauffage, utiliser des contenants réutilisables… Chaque geste compte pour préserver notre planète. 🌍💚', bonsGestesImage, null, null, 'manual'), new GeogroupNewsPost(6, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, "Optez pour le vélotaf : gagnez en forme physique, réduisez le stress, contribuez à l'environnement et évitez les embouteillages. Une journée active, responsable et fluide. 🚲🍃", avantagesVelotafImage, null, null, 'manual'), new GeogroupNewsPost(7, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, "Découvrez les 5 raisons d'utiliser Geovelo pour améliorer votre expérience à vélo ! 📱🚲", avantagesGeoveloImage, null, null, 'manual'), new GeogroupNewsPost(8, null, currentUser ? {
    id: currentUser.id,
    username: currentUser.username || '',
    profilePicture: currentUser.profilePicture || null
  } : null, true, now, "Geovelo est le choix idéal pour les cyclistes qui souhaitent bénéficier d'un GPS adapté à leur pratique, avec des fonctionnalités supplémentaires pour faciliter leur expérience sur la route. 🚀👌", comparatifGeoveloImage, null, null, 'manual')]);
  const [selectedModelId, selectModelId] = useState(models[0].id);
  const {
    palette
  } = useTheme();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    cancellablePromise,
    cancelPromises
  } = useCancellablePromise();
  useEffect(() => {
    return () => cancelPromises();
  }, []);
  async function handleSubmit() {
    if (!currentPartner || !geogroup || !currentUser) return;
    const model = models.find(({
      id
    }) => id === selectedModelId);
    if (!model) return;
    const {
      text
    } = model;
    setSubmitting(true);
    try {
      let photo;
      if (model.photo) {
        const res = await fetch(model.photo, {
          method: 'GET',
          headers: {
            'Content-Type': 'image/png'
          }
        });
        const blob = await res.blob();
        photo = new File([blob], model.photo.slice(model.photo.lastIndexOf('/') + 1));
      }
      await cancellablePromise(GeogroupService.addNewsPost(geogroup.id, {
        author_type: 'AUTHOR_AS_GROUP',
        text,
        photo: photo instanceof File ? photo : undefined,
        geo_group: geogroup.id
      }, currentPartner));
      enqueueSnackbar(t('commons.news_form.success_creation'));
      onCreated();
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.news_form.server_error_creation'), {
          variant: 'error'
        });
        setSubmitting(false);
      }
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    alignSelf: "stretch",
    marginBottom: "58px"
  }, alternate ? /*#__PURE__*/React.createElement(NewsModelFormContent, {
    alternate: true,
    isSubmitting: isSubmitting,
    models: models,
    palette: palette,
    selectedModelId: selectedModelId,
    selectModelId: selectModelId
  }) : /*#__PURE__*/React.createElement(_Card, {
    sx: {
      alignSelf: 'stretch',
      borderRadius: 4
    },
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(_CardContent, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      padding: 3
    }
  }, /*#__PURE__*/React.createElement(NewsModelFormContent, {
    isSubmitting: isSubmitting,
    models: models,
    palette: palette,
    selectedModelId: selectedModelId,
    selectModelId: selectModelId
  })))), /*#__PURE__*/React.createElement(StickyBar, {
    drawerWidth: drawerWidth
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    component: Link,
    disabled: isSubmitting,
    size: "large",
    startIcon: /*#__PURE__*/React.createElement(_Close, null),
    sx: {
      borderRadius: '8px !important'
    },
    to: prevPath,
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/React.createElement(Button, {
    disableElevation: true,
    color: "primary",
    disabled: isSubmitting,
    onClick: handleSubmit,
    size: "large",
    startIcon: isSubmitting ? /*#__PURE__*/React.createElement(_CircularProgress, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/React.createElement(SendIcon, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "contained"
  }, t('commons.news_form.actions.post')))));
}